import ApplicationsV3 from './Applications'
import TagsV3 from './Tags'
import BuildsV3 from './Builds'
import DeploysV3 from './Deploys'
import EnvironmentsV3 from './Environments'
import ConfigurationV3 from './Configuration'
import RepositoryV3 from './Repository'
import MonitoringV3 from './Monitoring'
import SourcesV3 from './Sources'
import TypesV3 from './Types'
import DomainV3 from './Domain'
import ModulesV3 from './Modules'
import SshV3 from './Ssh'
import SqliteV3 from './Sqlite'
import CacheV3 from './Cache'
import DeployScheduleV3 from './DeploySchedule'
import BackupV3 from './Backup'

class AppServiceV3 {
  constructor (id) {
    this.applications = new ApplicationsV3(id)
    this.tags = new TagsV3(id)
    this.builds = new BuildsV3(id)
    this.deploys = new DeploysV3(id)
    this.environments = new EnvironmentsV3(id)
    this.configuration = new ConfigurationV3(id)
    this.repository = new RepositoryV3(id)
    this.monitoring = new MonitoringV3(id)
    this.sources = new SourcesV3(id)
    this.types = new TypesV3(id)
    this.domain = new DomainV3(id)
    this.modules = new ModulesV3(id)
    this.ssh = new SshV3(id)
    this.sqlite = new SqliteV3(id)
    this.cache = new CacheV3(id)
    this.deploySchedule = new DeployScheduleV3(id)
    this.backup = new BackupV3(id)
  }
}

export default AppServiceV3
